import React from 'react';
import { SpeechRecognition } from '../types/speech';

interface ConversationInputProps {
  userInput: string;
  setUserInput: (value: string) => void;
  isLoading: boolean;
  isListening: boolean;
  speechRecognition: SpeechRecognition | null;
  continuousMicMode: boolean;
  onSendMessage: () => void;
  onToggleListening: () => void;
  onToggleContinuousMic: () => void;
  onKeyPress: (e: React.KeyboardEvent) => void;
}

const ConversationInput: React.FC<ConversationInputProps> = ({
  userInput,
  setUserInput,
  isLoading,
  isListening,
  speechRecognition,
  continuousMicMode,
  onSendMessage,
  onToggleListening,
  onToggleContinuousMic,
  onKeyPress,
}) => {
  return (
    <div>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '15px',
      }}>
        <div style={{
          fontSize: '18px',
          color: '#2c3e50',
          fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
          flex: 1,
          textAlign: 'center',
        }}>
          Ask me anything about The Hub Central!
        </div>
        {speechRecognition && (
          <label style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '14px',
            color: '#2c3e50',
            fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}>
            <input
              type="checkbox"
              checked={continuousMicMode}
              onChange={onToggleContinuousMic}
              style={{
                width: '18px',
                height: '18px',
                cursor: 'pointer',
              }}
            />
            <span>Keep mic on</span>
          </label>
        )}
      </div>
      <div style={{
        display: 'flex',
        gap: '10px',
        alignItems: 'stretch',
      }}>
        <input
          type="text"
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          onKeyPress={onKeyPress}
          placeholder={isListening ? "Listening..." : "Type your question or message..."}
          disabled={isLoading || isListening}
          style={{
            flex: 1,
            padding: '12px 16px',
            borderRadius: '12px',
            border: `2px solid ${isListening ? '#e74c3c' : '#f0f2f5'}`,
            fontSize: '16px',
            fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
            outline: 'none',
            transition: 'border-color 0.2s',
            backgroundColor: isLoading || isListening ? '#f8f9fa' : 'white',
          }}
          onFocus={(e) => !isListening && (e.target.style.borderColor = '#4ecdc4')}
          onBlur={(e) => !isListening && (e.target.style.borderColor = '#f0f2f5')}
        />
        <button
          onClick={onToggleListening}
          disabled={isLoading}
          style={{
            padding: '12px 16px',
            borderRadius: '12px',
            border: 'none',
            background: isListening ? '#e74c3c' : (speechRecognition ? '#3498db' : '#bdc3c7'),
            color: 'white',
            fontSize: '16px',
            fontWeight: '500',
            cursor: !isLoading && speechRecognition ? 'pointer' : 'not-allowed',
            transition: 'background-color 0.2s',
            minWidth: '60px',
            opacity: !speechRecognition ? 0.5 : 1,
          }}
          title={!speechRecognition ? 'Speech recognition not supported' : isListening ? 'Stop listening' : 'Start voice input'}
        >
          {isListening ? '🔴' : '🎤'}
        </button>
        <button
          onClick={onSendMessage}
          disabled={!userInput.trim() || isLoading}
          style={{
            padding: '12px 20px',
            borderRadius: '12px',
            border: 'none',
            background: userInput.trim() && !isLoading ? '#4ecdc4' : '#bdc3c7',
            color: 'white',
            fontSize: '16px',
            fontWeight: '500',
            cursor: userInput.trim() && !isLoading ? 'pointer' : 'not-allowed',
            transition: 'background-color 0.2s',
            minWidth: '60px',
          }}
        >
          {isLoading ? '⏳' : '➤'}
        </button>
      </div>
    </div>
  );
};

export default ConversationInput;